import { message } from 'antd';
import { t } from './lang';

const duration = 3;

export const messageSuccess = (config) => {
  message.success({ ...config, duration });
};

export const messageError = (config) => {
  message.error({ ...config, duration });
};

export const messageDestroy = () => {
  message.destroy();
};

export const messageLoading = (config) => {
  return message.loading({ ...config, duration });
};

export const messageAction = {
  banAccount: (action = '', account = '') => {
    messageSuccess({
      key: 'banAccount',
      content: t('message.ban_account', { action, account }),
    });
  },

  updateProfileSuccess: (data) => {
    messageSuccess({
      content: t('message.update_profile_success'),
    });
  },

  approveAccount: (action = '', account = '') => {
    messageSuccess({
      key: 'approveAccount',
      content: t('message.approve_account', { action, account }),
    });
  },
};
